






























































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";

import Add from "./phone_add.vue";
import Edit from "./phone_edit.vue";

@Component({
  components: {
    Add,
    Edit,
  },
})
export default class extends Mixins(MyList) {
  dispatchType: string = "privatetel/phones";

  dispatchTypeDelete: string = "privatetel/phonedelete";

  deleteConfirmContent: string = "你确定要删除该记录吗？";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "号码", dataIndex: "private_num" },
    { title: "次数", dataIndex: "total_count" },
    { title: "可用次数", dataIndex: "usable_count" },
    { title: "拨打状态", dataIndex: "event_type" },
    { title: "操作", scopedSlots: { customRender: "action" } },
  ];

  mounted() {
    this.loadData();
  }
}
